module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder-symlink-a1ee74dd.svg";